module.exports = __webpack_public_path__ + "lodding.gif?2da49bd1c872f9cdb8ef0e35599aaf92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lodding.gif
// module id = 566
// module chunks = 0